function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ElementModel } from './ElementModel';
import { EditorConfig } from '../../edit/EditorConfig';
import { backgroundElementsUndoOrigin, elementsUndoOrigin } from '../../utils/constant';
export class ImageModel extends ElementModel {
  get src() {
    return this.root.get('src');
  }
  constructor(root, scope, imageSets, liveCursor, isPerformanceMode) {
    super(root, scope, liveCursor, isPerformanceMode);
    _defineProperty(this, "item", null);
    _defineProperty(this, "imageSets", void 0);
    _defineProperty(this, "imageElement", null);
    _defineProperty(this, "imageLoadVersion", 0);
    _defineProperty(this, "clearLocalPointsWhenYPointsChange", true);
    _defineProperty(this, "shouldUseLocalPoints", true);
    _defineProperty(this, "localPointsPick", 4);
    this.imageSets = imageSets;
    if (!this.root.has('type')) {
      this.root.set('type', 'image');
    }
    this.root.set(ElementModel.KEYS.shadow, '');
  }
  subDispose() {
    this.imageLoadVersion++;
    if (this.imageElement) {
      this.imageElement.onload = null;
      this.imageElement.onerror = null;
      this.imageElement.remove();
      this.imageElement = null;
      return;
    }
    const img = this.imageSets.querySelector(`[id='${this.uuid}']`);
    if (img) {
      img.onload = null;
      img.onerror = null;
      img.remove();
    }
  }
  bindImageLoad(img) {
    const loadVersion = ++this.imageLoadVersion;
    img.onload = () => {
      // Re-apply the synced matrix after the underlying image resource is ready.
      // Without this, a Raster created before image load can keep stale sizing.
      if (this.imageLoadVersion !== loadVersion || !this.item) {
        return;
      }
      // this.onVectorUpdate();
    };
    img.onerror = null;
  }
  createPaperItem() {
    if (this.item) {
      return;
    }
    let img = this.imageSets.querySelector(`[id='${this.uuid}']`);
    if (!img) {
      img = document.createElement('img');
      img.crossOrigin = 'anonymous';
      img.id = this.uuid;
      this.imageSets.appendChild(img);
    }
    this.imageElement = img;
    this.bindImageLoad(img);
    img.src = this.src;
    this.item = new this.scope.Raster(this.uuid);
    const matrix = new this.scope.Matrix(this.pointsMatrix);
    this.item.matrix = matrix;
    this.item.data.role = this.role;
  }
  onVectorUpdate() {
    const matrix = new this.scope.Matrix(this.pointsMatrix);
    if (this.item) {
      this.item.matrix = matrix;
    }
  }
  vectorKeys() {
    return [];
  }
  styleKeys() {
    return {
      include: ['src'],
      exclude: ['dashArray', 'strokeColor', 'fillColor', 'strokeWidth']
    };
  }
  onStyleKeyUpdate(key) {
    if (key === 'src') {
      const imgElement = this.imageElement ?? this.imageSets.querySelector(`[id='${this.uuid}']`);
      if (imgElement) {
        this.imageElement = imgElement;
        this.bindImageLoad(imgElement);
        imgElement.src = this.src;
      }
    }
  }
  editorConfig() {
    const cfg = new EditorConfig();
    cfg.resizeModel = () => 'four-corner';
    cfg.uniformScale = () => true;
    cfg.translatable = () => !this.isBackground;
    return cfg;
  }
  mutationOrigin() {
    return this.isBackground ? backgroundElementsUndoOrigin : elementsUndoOrigin;
  }
  liveCursorPoint() {
    return null;
  }
}